import useEmblaCarousel from "embla-carousel-react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { ProductCard } from "@/theme1/components/product/ProductCard";

export default function RecommendationCarousel({ products = [] }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start",
    dragFree: true,
  });

  const normalizedProducts = products.map(normalizeProductForCard);

  return (
    <div className="space-y-5">
      <div className="flex justify-end gap-2">
        <button
          type="button"
          onClick={() => emblaApi?.scrollPrev()}
          className="flex size-10 items-center justify-center rounded-full border border-border bg-white"
        >
          <ArrowLeft className="size-4" />
        </button>

        <button
          type="button"
          onClick={() => emblaApi?.scrollNext()}
          className="flex size-10 items-center justify-center rounded-full bg-foreground text-background"
        >
          <ArrowRight className="size-4" />
        </button>
      </div>

      <div ref={emblaRef} className="overflow-hidden">
        <div className="-ml-4 flex">
          {normalizedProducts.map((product) => (
            <div
              key={product.id}
              className="min-w-0 flex-[0_0_80%] pl-4 sm:flex-[0_0_45%] lg:flex-[0_0_25%]"
            >
              <ProductCard product={product} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function normalizeProductForCard(product) {
  const mainImage =
    product.image ||
    product.imageUrl ||
    product.thumbnail ||
    product.gallery?.[0]?.src ||
    product.images?.[0]?.src ||
    product.images?.[0];

  const hoverImage =
    product.hoverImage ||
    product.gallery?.[1]?.src ||
    product.images?.[1]?.src ||
    product.images?.[1] ||
    mainImage;

  return {
    ...product,

    title: product.title || product.name,
    name: product.name || product.title,

    image: mainImage,
    imageUrl: mainImage,
    thumbnail: mainImage,
    hoverImage,

    images: [
      {
        src: mainImage,
        alt: `${product.title || product.name} main view`,
      },
      {
        src: hoverImage,
        alt: `${product.title || product.name} alternate view`,
      },
    ],

    gallery: [
      {
        type: "image",
        src: mainImage,
        alt: `${product.title || product.name} main view`,
      },
      {
        type: "image",
        src: hoverImage,
        alt: `${product.title || product.name} alternate view`,
      },
    ],

    compareAtPrice: product.compareAtPrice || product.comparePrice,
    comparePrice: product.comparePrice || product.compareAtPrice,

    badges:
      product.badges ||
      [
        product.isNew ? "New" : null,
        product.isBestSeller ? "Best Seller" : null,
        product.discount ? "Sale" : null,
      ].filter(Boolean),
  };
}